import React from "react";
import GaugeChart from "react-gauge-chart";
import { Box, Typography } from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

const HOEScoreGaugeCard = ({ HOE = 0, target = 75 }) => {
  // const value = Math.max(0, Math.min(HOE, target));
  // const percent = value / target;
  const percent = Math.max(0, Math.min(HOE, 100)) / 100;

  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #022964, #1b6ef4)",
        borderRadius: "16px",
        padding: "24px",
        color: "#fff",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
        width : "100%",
        maxWidth : "400px",
        height : '100%',
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      {/* Header */}
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <EmojiEventsIcon sx={{ fontSize: 28, color: "#FFD700" }} />
        <Typography fontSize="20px" fontWeight={600}>
          HOE Score
        </Typography>
      </Box>

      {/* Gauge Chart */}
      <Box width="100%" maxWidth="300px" mt={4}>
         <GaugeChart
        id="plain-gauge"
        nrOfLevels={50}
        percent={percent}
        colors={["#e74c3c", "#f1c40f", "#2ecc71"]}
        arcPadding={0.02}
        arcWidth={0.3}
        hideText={false} // true if you want no percentage inside
        needleColor="#333"
        needleBaseColor="#333"
        textColor="#ffffffff"
        style={{
          width : "100%",
          background: "transparent", // removes boxy background
        }}
      />
      </Box>

      {/* Score Value */}
      {/* <Typography variant="h3" fontWeight={700} mt={2}>
        {HOE}%
      </Typography> */}

      {/* Status */}
      <Typography fontSize="14px" sx={{ mt: 1, opacity: 0.85 }}>
        Target: {target}% —{" "}
        <span style={{ fontWeight: 600 }}>
          {percent < 1 ? "In Progress" : "Completed"}
        </span>
      </Typography>
    </Box>
  );
};

export default HOEScoreGaugeCard;
